export default {
  meta: {
    title: '踩点宝-门店地图',
    url: '/footprinting/map', //  埋点字段，上报归属的模块
    urlName: '踩点宝' //  埋点字段，上报归属的模块
  }
};
